// extracted by mini-css-extract-plugin
export default {"add-marker":"CustomAction_add-marker__Laibt","desc-location":"CustomAction_desc-location__cQTUd","icon":"CustomAction_icon__EuSFY"};